module.exports = __webpack_public_path__ + "img/func2.a023322e.png";